import { environment } from '../../environments/environment';

export const AppConsts = {
  IS_ENV_PRODUCTION: environment.production,
  APPLICATION_NAME:"DÉCISIEL",
  DATE_FORMAT: 'DD/MM/YYYY',
  TOKEN_KEY: "auth-token",
  XSRF_TOKEN_NAME:"xsrf-token",
  API_URL: environment.API_URL,
  API_SERVICE_URL: environment.API_SERVICE_URL,
  API_SIMULATEUR_URL: environment.API_SIMULATEUR_URL,
  API_SIMULATEUR_KEY: environment.API_SIMULATEUR_KEY,
  RECAPTCHA_SITE_KEY: environment.RECAPTCHA_SITE_KEY,
  USER_NAME: "user-name",
  USER_IMAGE: "user-image",
  USER_MAIL: "user-mail",
  USER_ROLES: "user-roles",
  PASSWORD_PATTERN: "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[*.! ?@#$%^&~={}():_;<>|\\-`.+,/\"]).{8,}$", 
  TEL_PATTERN: "^((\\+33-?)|0)?[0-9]{8,10}$", 
  EMAIL_PATTERN: "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,10}$",
  REMEMBER_ME: "remember-me",
  RepriseCreation: [
    {label:"Création", value:"Création"},
    {label:"Reprise", value:"Reprise"}
  ],
  AllPaymentMethods: [
    { label: "Chèque", value: "Check" },
    { label: "Prélèvement", value: "Sample" }
  ],
  StatutJuridique : [
    {label:"SAS", value:"SAS"},
    {label:"SASU", value:"SASU"},
    {label:"SARL", value:"SARL"},
    {label:"EURL", value:"EURL"},
    {label:"SCI", value:"SCI"},
    { label: "LMNP", value: "LMNP" },
    { label: "SASU a capital variable", value: "SASU a capital variable" },
    { label: "SCI a capital variable", value: "SASU a capital variable" },
  ],
  RegimesFiscales : [
    { label: "BIC / IR", value:"BIC / IR"},
    { label: "IS", value: "IS" },
    { label: "BNC", value: "BNC" },
  ],
  Civitiltes : [
    { label: 'M.', value: {id: 2, name: "M."} },
    { label: 'Mme.', value: {id: 1, name:"Mme."} }
  ],
  SIE: 'Service impôts Entreprises',
  CentreGestion: 'Centre de Gestion',
  TribunalCommerce: 'Tribunal de Commerce',
  AllFonctionsActionnaire : [
    {Libelle : 'Président',Value:'P',IsChecked : false},
    {Libelle : 'Directeur général',Value:'DG',IsChecked : false},
    {Libelle : 'Gérant',Value:'G',IsChecked : false},
    {Libelle : 'Autre',Value:'A',IsChecked : false}
  ],
  TypesMissions :[{type:'Comptabilité',id:1},{type:'Portage',id:2}],
  TypeRembourcementsForfaitaire: [
    {label : '', value: null},
    {label : 'Frais kilométriques', value: 'Frais kilométriques'},
    {label : 'Frais réels', value: 'Frais réels'},
    {label : 'Carte orange', value: 'Carte orange'}
  ],
  TypeContrat : [
    {label : '', value: null},
    {label : 'indéterminée', value: 'indéterminée'},
    {label : 'déterminée', value: 'déterminée'}
  ],
  TypeHoraire : [
    {label : '', value: null},
    {label : 'Temps plein', value: 'Temps plein'},
    {label : 'Temps partiel', value: 'Temps partiel'}
  ],
  MissionList : [
    {label: '', value: null},
    {label: 'Comptabilité', value: 'Comptabilité'},
    {label: 'Portage', value: 'Portage'}
  ],
  QuestionnaireImpacts: [
    {label: null, value: null},
    {label: 'Elevé', value: 'Elevé'},
    {label: 'Moyen', value: 'Moyen'},
    {label: 'Faible', value: 'Faible'}
  ],
  QuestionnaireReponses: [
    {label: '', value: null},
    {label: 'Oui', value: 'IsYes'},
    {label: 'Non', value: 'IsNo'},
    {label: 'NA', value: 'IsNA'}
  ],
  QuestionnaireTypes: [
    {label: 'LAB', value: 'LAB'},
    {label: 'ECCV', value: 'ECCV'},
    {label: 'Acceptation et maintien de la mission', value: 'ACCEPTANCE_MISSION'}
  ],
  QuestionnaireStatus: [
      {label: 'Envoyé', value: 1},
      {label: 'Traité', value: 4}
  ],
  AuditProgramme: 'Decisiel CFN Web',
  ChartColors: ['#4dc9f6', '#f67019', '#f53794', '#FFF033', '#33E3FF', '#33FFC7', '#96FF33', '#F3FF33', '#FFC133', '#FF7A33', '#FF4933', '#FF33DA', '#D733FF'],
  Panier:{
    DocumentsToGenerate : 'DocumentsToGenerate'
  },
  situationFamiliale : [
    {label : 'Marié', value :  'Marié'},
    {label : 'Célibataire', value :  'Célibataire'}
  ],
  SimulateurSocietePresentationCabinetPdf: 'https://vadimdez.github.io/ng2-pdf-viewer/assets/pdf-test.pdf',
  DecisielCurrentEmail:"DecisielCfnCurrentEmail",
  DecisielCurrentTwoFactorProvider:"DecisielCfnCurrentTwoFactorProvider",
  IsTwoFactorRememberClient:"IsTwoFactorRememberClientCfn",
  SOCIETE_PORTAGE_AUTRE: 'Autre',
  YES_NO : [{label: 'Oui', value: 1}, {label: 'Non', value: 0}],
  TYPE_CONTRAT : [{label: 'CDI', value: 'CDI'}, {label: 'CDD', value: 'CDD'}],
  CIVILITIES_STRING_VALUES : [ {label: 'M.', value: 'M.'}, {label: 'Mme.', value: 'Mme.'} ]
};

export const USER_ROLES = {
  ADMINSTRATOR : "Administrateur",
  CHEF_MISSION : "Chef de mission",
  COMPTABLE : "Comptable",
  JURIDIQUE : "Juridique",
  PORTAGE_SALARIAL : "Portage Salarial",
  COMPTES_ANNUELS : "Comptes annuels",
  VISA_FISCAL : "Visa fiscal",
  SERVICE_SOCIAL : "Service social",
  EXPERT_COMPTABLE : "Expert comptable",
  AIDE_COMPTABLE : "Aide comptable",
  RESPONSABLE_PAIE:"Responsable paie",
  RESPONSABLE_CONGE:"Responsable congé"
};
